import React from 'react';
import { Button, Checkbox, InputNumber, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { DEFAULT_CONTOUR_LOD, normalizeContourLodSettings } from '../../utils/contourLodSettings';

/**
 * 等高线管理页：按离地高度自动抽稀
 */
export default function ContourLodSettingsPanel({
  mapSettings,
  setMapSettings,
  handleSaveMapSettings,
  mapSettingsMsg
}) {
  const lod = normalizeContourLodSettings(mapSettings?.contour_lod);

  const updateLod = (patch) => {
    setMapSettings((prev) => ({
      ...prev,
      contour_lod: normalizeContourLodSettings({
        ...normalizeContourLodSettings(prev.contour_lod),
        ...patch
      })
    }));
  };

  const patchLodStep = (idx, patch) => {
    const steps = (lod.steps || []).map((s, i) => (i === idx ? { ...s, ...patch } : s));
    updateLod({ steps });
  };

  const addLodStep = () => {
    const last = lod.steps[lod.steps.length - 1] || { aboveMeters: 1500, interval: 50 };
    updateLod({
      steps: [...lod.steps, { aboveMeters: last.aboveMeters + 1500, interval: 0 }]
    });
  };

  const removeLodStep = (idx) => {
    updateLod({ steps: lod.steps.filter((_, i) => i !== idx) });
  };

  return (
    <div style={{
      marginBottom: 20,
      padding: 12,
      border: '1px solid #f0f0f0',
      borderRadius: 8,
      background: '#fafafa'
    }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <h4 style={{ margin: 0 }}>按离地高度抽稀</h4>
        <Button type="primary" size="small" onClick={handleSaveMapSettings}>保存抽稀设置</Button>
        {mapSettingsMsg && (
          <span style={{ color: mapSettingsMsg.includes('成功') ? 'green' : 'red', fontSize: 13 }}>
            {mapSettingsMsg}
          </span>
        )}
      </div>
      <div style={{ color: '#666', fontSize: 13, marginBottom: 8 }}>
        指挥台右上角「离地高度」升高后，自动改用更大等高距；最高一档可设为 0 米表示隐藏。近处仍用成品菜单里的 5/10/20/30m。
      </div>
      <Checkbox
        checked={lod.enabled !== false}
        onChange={(e) => updateLod({ enabled: e.target.checked })}
      >
        启用按离地高度自动抽稀
      </Checkbox>
      <div style={{ marginTop: 10 }}>
        {(lod.steps || []).map((step, idx) => (
          <div
            key={idx}
            style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 8 }}
          >
            <span style={{ fontSize: 13 }}>离地 ≥</span>
            <InputNumber
              min={0}
              max={50000}
              step={100}
              value={step.aboveMeters}
              onChange={(v) => patchLodStep(idx, { aboveMeters: v })}
            />
            <span style={{ fontSize: 13 }}>米时，等高距</span>
            <InputNumber
              min={0}
              max={1000}
              step={10}
              value={step.interval}
              onChange={(v) => patchLodStep(idx, { interval: v })}
            />
            <span style={{ fontSize: 13, color: '#666' }}>
              米{Number(step.interval) === 0 ? '（隐藏）' : ''}
            </span>
            <Button
              type="text"
              danger
              icon={<MinusCircleOutlined />}
              onClick={() => removeLodStep(idx)}
              disabled={(lod.steps || []).length <= 1}
            />
          </div>
        ))}
        <Space>
          <Button type="dashed" icon={<PlusOutlined />} onClick={addLodStep}>
            增加一档
          </Button>
          <Button type="link" onClick={() => updateLod(DEFAULT_CONTOUR_LOD)}>
            恢复默认（1500→50m，3000→100m，8000→隐藏）
          </Button>
        </Space>
      </div>
    </div>
  );
}
